var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: 56,
    x2: 53,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 56,
    x2: 23,
    y2: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 32c0-6.63 6.72-12 15-12s15 5.37 15 12"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 8,
    x2: 11,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 20,
    x2: 11,
    y2: 56
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinBlack);
export default __webpack_public_path__ + "static/media/linkedin-black.bf5a8cd61dd9bc334fcd4915626edb32.svg";
export { ForwardRef as ReactComponent };